import React, { useState } from "react";
import "./auth.css";
import { Btn, OTPInput, SuccessComp } from "../../utils/utils";
import logo from "../../assets/home-logo.png";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "iconsax-react";
import { AxiosPost } from "../../api/api";

const OtpComp = () => {
  const url = "auth/reset-password/verify/";
  const urlResend = "auth/reset-password/code/";
  const navigate = useNavigate();
  const email = localStorage.getItem("reset-email");
  const [isLoading, setIsLoading] = useState(false);
  const [isRLoading, setIsRLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otp, setOtp] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [sucessMsg, setSucessMsg] = useState("");


  const handleOtpChange = (otp) => {
    setOtpError("");
    setOtp(otp);
  };

  const dataObj = {
    email: email,
    code: otp
  };

  const clickCont = () => {
    setIsLoading(true);
    AxiosPost(url, dataObj).then((res) => {
      // console.log(res);
      setSuccessMsg(res.message);
      localStorage.setItem("otp", otp);
      setTimeout(() => {
        navigate("/auth/new-password");
        setSuccessMsg("");
      }, 3000);
      setIsLoading(false);
    }).catch((err) => {
      // console.log(err.response);
      setOtpError(err?.response?.data?.errors[0].error);
      setIsLoading(false);
    })
  };

    const dataObjResend = {
      email: email,
    };
  
    const clickResend = () => {
      setIsRLoading(true);
      AxiosPost(urlResend, dataObjResend)
        .then((res) => {
          // console.log(res);
          setSucessMsg(res.message);
          setTimeout(() => {
            setSucessMsg("");
          }, 3000);
          setIsRLoading(false);
        })
        .catch((err) => {
          // console.log(err.response);;
          setIsRLoading(false);
        });
    };

  return (
    <div className="forgot">
      <SuccessComp message={successMsg || sucessMsg} />
      <img src={logo} alt="logo" />
      <div className="forgot-form">
        <h3>Password reset</h3>
        <p>We sent a code to {email}</p>
        <OTPInput length={4} onChange={handleOtpChange} />
        <p style={{fontFamily: "Work Sans", color: "red"}}>{otpError}</p>
        <div className="otp-btn_cont">
          <Btn
            btnClass={"home-btn"}
            btnText={"Continue"}
            btnClick={clickCont}
            btnWidth={"100%"}
            loading={isLoading}
          />
        </div>
        <p>
          Didn’t get the code? <span onClick={clickResend} style={{cursor: isRLoading && "not-allowed"}}>click to resend</span>
        </p>
        <Link to={"/auth/signin"} style={{ textDecoration: "none" }}>
          <div className="go-back">
            <ArrowLeft color="#444" size={24} />
            <p>Back to Login</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default OtpComp;
